export const getPublicUrlBase = () => {
  const envBase = (process.env.PUBLIC_URL || '').trim();
  if (envBase && envBase !== '/') {
    return envBase.startsWith('/') ? envBase : `/${envBase}`;
  }

  if (typeof window === 'undefined') return '';

  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  if (pathSegments.length > 0) {
    return `/${pathSegments[0]}`;
  }

  return '';
};

export const buildCandidateUrls = (url) => {
  if (!url || typeof url !== 'string') return [];

  const normalized = url.startsWith('/') ? url : `/${url}`;
  const publicBase = getPublicUrlBase();
  const candidates = [normalized];

  if (publicBase) {
    candidates.push(`${publicBase}${normalized}`);
  }

  return [...new Set(candidates)];
};
